import React, { useEffect, useMemo, useState } from "react";
import { Form, Formik } from "formik";
import editIcon from "../../Images/edit.svg";
import { create } from "../../DataApi/create";
import { useSession } from "../../authentications/SessionContext";
import { read } from "../../DataApi/read";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import LoaderWrapper from "../Loader/LoaderWrapper";
import { handleResponse } from "../../utilities/handleResponse";
import FormikInput from "../Formik/FormikInput";
import { write } from "../../DataApi/write";
import SVGButton from "../Buttons/SVGButton";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
import { FormContainer } from "../StyledComponents/FormConatiner/FormContainerStyle";
import useFormikSubmitButton from "../../CustomHooks/useFormikSubmitButton";
import { primaryColor } from "../../utilities/colors";
import newBrandFormValidationSchema from "../../utilities/Validation Schema/NewBrandFormValidationSchema";
import Translator from "./Translator";
import SetTranslation from "./SetTranslations";
import Modal from "../Kanban/Modal/Modal";

const NewBrand = ({
  handleCloseModal,
  selectedRecord = {},
  refetchData,
  defaultEdit,
  setDefaultEdit,
}) => {
  const { sessionInfo = true } = useSession();
  const { company_id, context, isVTEX } = sessionInfo;

  const { language, translations } = useLanguage();
  const t = translations[language];

  const [isLoading, setIsLoading] = useState(true);

  const [modalType, setModalType] = useState("view");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [updatedData, setUpdatedData] = useState([]);

  const { ConfirmationModal, toggleModal, setMetaData, setTitle } =
    useConfirmationModal();

  const { isSubmitting, setIsSubmitting, FormikSubmitButtons } =
    useFormikSubmitButton();

  const [formData, setFormData] = useState({
    name: "",
  });
  const modelName = "product.template.brand";

  const getPayload = (payload) => {
    return payload;
  };
  const handleAddBrand = async (values) => {
    const payload = getPayload(values);
    let response = await create({
      payload,
      context,
      company_id,
      model: modelName,
    });
    response = JSON.parse(response);
    if (response?.result) {
      handleCloseModal();
    }
    return response;
  };
  const handleEditForm = async (values) => {
    // console.log("write api", values);
    const newChanges = {};
    const oldPayload = getPayload(formData);
    const newPayload = getPayload(values);

    Object.keys(newPayload).forEach((key) => {
      if (JSON.stringify(newPayload[key]) !== JSON.stringify(oldPayload[key])) {
        newChanges[key] = newPayload[key];
      }
    });
    if (Object.keys(newChanges).length === 0) {
      handleCloseModal();
      return false;
    }
    let response = await write({
      id: selectedRecord?.id,
      change: newChanges,
      company_id,
      context,
      model: modelName,
    });
    response = JSON.parse(response);
    if (response?.result) {
      // console.log("write resp", response);
      handleCloseModal();
      // refetchData();
    }
    return response;
  };

  const handleSubmitForm = async (...args) => {
    const [values, { setFieldError, setFieldTouched }] = args;

    setIsSubmitting(true);
    let response = {};
    let successMessage = "Brand Created Successfully";

    if (modalType === "edit") {
      successMessage = "Brand Edited Successfully";
      response = await handleEditForm(...args);
    } else if (modalType === "add") {
      response = await handleAddBrand(...args);
    }
    setIsSubmitting(false);
    handleResponse({
      response,
      setMetaData,
      setTitle,
      successMessage,
    });
    toggleModal();
  };

  const fetchBrandDetails = async () => {
    let response = await read({
      id: selectedRecord.id,
      change: ["name"],
      context,
      company_id,
      model: modelName,
    });
    response = JSON.parse(response);
    if (response?.result) {
      response = response?.result[0];
      // console.log("initial brand read resp", response);
      setFormData({
        ...response,
        name: response?.name,
      });
      setIsLoading(false);
      return response;
    }
  };

  useEffect(() => {
    if (selectedRecord?.id) {
      setModalType("view");
      fetchBrandDetails().then((response) => {
        // console.log("brand read response in view mode in then func", response);
        // const parent_id = response.parent_id || "";
      });
    } else {
      setModalType("add");

      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    if (modalType === "edit") {
      // console.log("brand edit mode");
    }
  }, [modalType]);

  const disableInputs = useMemo(() => modalType === "view", [modalType]);
  return (
    <>
      <ConfirmationModal />
      {isCreateModalOpen && (
        <Modal isOpen={isCreateModalOpen} onClose={handleCloseModal}>
          <SetTranslation
            handleCloseModal={(modalValue) => setIsCreateModalOpen(false)}
            data={updatedData}
          />
        </Modal>
      )}
      <Formik
        enableReinitialize
        initialValues={formData}
        validationSchema={newBrandFormValidationSchema}
        onSubmit={handleSubmitForm}
      >
        {({
          values,
          setFieldValue,
          validateForm,
          setErrors,
          setFieldTouched,
        }) => (
          <Form>
            <div
              className={`container ${modalType === "view" ? "mb-4" : ""}`}
              style={{ width: "1000px", padding: "10px" }}
            >
              <FormContainer className="row g-3">
                <div className="row p-0 justify-content-between align-items-center">
                  <div className="col">
                    <h3
                      className="me-2 mb-2 "
                      style={{
                        fontFamily: "Inter",
                        color: "#323B4B",
                        fontWeight: 600,
                      }}
                    >
                      {modalType === "add" && t["Add New Brand"]}
                      {modalType === "edit" && t["Edit Brand"]}
                      {modalType === "view" && t["Brand"]}
                    </h3>
                  </div>
                  {modalType === "view" && (
                    <div className="col d-flex justify-content-end p-0">
                      <SVGButton
                        hoverColor={isVTEX ? primaryColor.primary : "#ff5837"}
                        icon={editIcon}
                        onClick={() => {
                          setModalType("edit");
                        }}
                        className="me-2"
                      />
                    </div>
                  )}
                </div>
                <LoaderWrapper
                  isLoading={isLoading}
                  height="70vh"
                  width="800px"
                >
                  <div className="d-flex justify-content-between align-items-center col-12 gap-5">
                    <div className="col-6 d-flex flex-column gap-3">
                      <div className="col-12" style={{ position: "relative" }}>
                        {!disableInputs && (
                          <Translator
                            productId={selectedRecord?.id || ""}
                            modelSpecific={"product.template.brand"}
                            color={primaryColor.primary}
                            fieldName={"name"}
                            fieldValue={values.name}
                            isCreateModalOpen={isCreateModalOpen}
                            setIsCreateModalOpen={setIsCreateModalOpen}
                            updatedData={updatedData}
                            setUpdatedData={setUpdatedData}
                          />
                        )}
                        <FormikInput
                          disabled={disableInputs}
                          name="name"
                          label={t["Brand Name"]}
                        />
                      </div>
                    </div>
                  </div>

                  {/* <ErrorFocus /> */}

                  {!disableInputs && (
                    <FormikSubmitButtons handleCloseModal={handleCloseModal} />
                  )}
                </LoaderWrapper>
              </FormContainer>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default NewBrand;
